import { Box, Typography } from "@mui/material";
import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function EmailValidated(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography
        sx={{
          color: "#ED6C02",
          fontWeight: "500px",
          fontSize: "24px",
          lineHeight: "32.02px",
          fontFamily: "inter",
        }}
      >
        {t("emailValidation.validateEmail")}
      </Typography>

      <Typography
        sx={{
          color: "#676767",
          fontWeight: "400px",
          fontSize: "14px",
          lineHeight: "20.02px",
          letterSpacing: "0.17px",
        }}
      >
        {t("emailValidation.requestNewLink")}
      </Typography>

      <Typography
        sx={{
          color: "#1B1B1B",
          fontWeight: "400px",
          fontSize: "16px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
          fontFamily: "inter",
          margin: "2rem 0 2rem 0",
        }}
      >
        {t("emailValidation.emailNotValidated")}
      </Typography>

      <Typography
        sx={{
          color: "#1B1B1B",
          fontWeight: "400px",
          fontSize: "16px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
          fontFamily: "inter",
        }}
      >
        {t("emailValidation.indispensableStepPortal")}
      </Typography>

      <Typography
        sx={{
          color: "#1B1B1B",
          fontWeight: "400px",
          fontSize: "16px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
          fontFamily: "inter",
        }}
      >
        {t("emailValidation.accessRegistrationEmail")}
      </Typography>

      <Typography
        sx={{
          color: "#E65100",
          fontWeight: "400px",
          fontSize: "16px",
          lineHeight: "28px",
          letterSpacing: "0.15px",
          fontFamily: "inter",
        }}
      >
        {t("emailValidation.linkExpires")}
      </Typography>
    </Box>
  );
}

export const Route = createFileRoute("/__public/email-validated/")({
  component: EmailValidated,
});
